function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	if (
		!!document.querySelector("#login_registration_container") &&
		!!document.querySelector("#user_nav #_user_panel_container") === false
	) {
		window.globalLoginWindowHandler.paywallLogin(
			document.querySelectorAll("._paywall_subscribe"),
		);
		window.globalLoginWindowHandler.paywallLogin([
			document.querySelector("#_paywall_redeem"),
		]);
		window.globalLoginWindowHandler.paywallLogin([
			document.querySelector("#_twitch_plus"),
		]);
	}
});
